// extracted by mini-css-extract-plugin
export default {"project":"Project_project__x8Z93","container":"Project_container__hxmRt","hover":"Project_hover__ia6Vn","buttons":"Project_buttons__EZrsQ","title":"Project_title__DqKbo"};